// extracted by mini-css-extract-plugin
module.exports = {"chipcarousel":"ChipCarousel-module--chipcarousel--1e1UT","chip":"ChipCarousel-module--chip--_0oaH","chiplist":"ChipCarousel-module--chiplist--1Hsrs"};